import { MENU_MANAGER_ENRICHMENTS } from 'config/routes';
import { Navigate, useParams } from 'react-router-dom';

export const AvailabilityRedirect: React.FC = () => {
    const { locationId, menuChangeId, menuId } = useParams<{
        locationId?: string;
        menuChangeId?: string;
        menuId?: string;
    }>();
    return (
        <Navigate
            to={MENU_MANAGER_ENRICHMENTS.replace(':locationId', locationId)
                .replace(':tabId', 'weekly-availability')
                .replace(':menuChangeId', menuChangeId)
                .replace(':menuId', menuId)}
            replace
        />
    );
};
